import { render, staticRenderFns } from "./reading.vue?vue&type=template&id=77d5ceb4&scoped=true"
import script from "./reading.vue?vue&type=script&lang=js"
export * from "./reading.vue?vue&type=script&lang=js"
import style0 from "./reading.vue?vue&type=style&index=0&id=77d5ceb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5ceb4",
  null
  
)

export default component.exports